// extracted by mini-css-extract-plugin
export default {"user":"styles_user__AnU5O","userInfo":"styles_userInfo__nqx97","santaIcon":"styles_santaIcon__GuSdR"};